export const achievements = {
  coding: [
    {
      platform: "LeetCode",
      description: "Solved 400+ problems",
      rank: "3-star rating",
      link: "https://leetcode.com/u/Ahmad197/"
    },
    {
      platform: "CodeChef",
      description: "60+ coding contests completed, improving algorithms and logic",
      rank: "2-star rating ",
      link:"https://www.codechef.com/users/ahmad197"
    },
    {
      platform: "Coding Ninjas",
      description: "Solved 250+ problems",
      rank: "Master title",
      link:"https://www.naukri.com/code360/profile/Ahmad697"
    },
    
    {
      platform: "GeeksforGeeks",
      description: "Solved 300+ problems",
      rank: "3-star rating",
      link:"https://www.geeksforgeeks.org/user/221fa04697/"
    }
  ],
  hackathons: [
    {
      position: "1st Prize",
      event: "Web Hackathon, VCode 2025"
    },
    {
      position: "2nd Prize",
      event: "Code Hunt, VCode 2025"
    }
  ]
};